import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonPrimaryComponent } from 'projects/components/button-primary/button-primary.component';
import { PinEntryComponent } from 'projects/components/pin-entry/pin-entry.component';
import { AuthService } from 'projects/login/src/app/services/auth/auth.service';

@Component({
  selector: 'pay-login-lost-mfa-verify',
  imports: [ButtonPrimaryComponent, TranslatePipe, PinEntryComponent, ReactiveFormsModule],
  templateUrl: './lost-mfa-verify.component.html',
})
export class LostMfaVerifyComponent {
  private readonly _router = inject(Router);
  private readonly _authService = inject(AuthService);

  code: string = '';

  returnToLogin() {
    this._router.navigateByUrl('/').then();
  }

  setCode(code: string) {
    this.code = code;
  }

  submit() {
    if (!this.code || this.code.length !== 6) {
      return;
    }

    this._authService.mfaLostVerify(this.code).subscribe({
      next: () => {
        this._router.navigateByUrl('/lost-2fa-email').then();
      },
      error: () => {
        this._router.navigateByUrl('/lost-2fa').then();
      },
    });
  }
}
